import { useState, useEffect } from "react";
import axios from "axios";


const useCompressImageConfig = () => {
    const [compressResolutionFormat, setCompressResolutionFormat] = useState({
        audios: 0,
        episode: 0,
        season: 0,
        series: 0,
        live: 0,
        videos: 0,
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchCompressImageConfig = async () => {
            try {
                setLoading(true);
                setError(null);
                const token = await localStorage.getItem('access_token');
                const headers = { Authorization: `Bearer ${token}` };
                const response = await axios.get(
                    `${process.env.REACT_APP_Baseurl}/admin/compress_image`,
                    { headers }
                );
                setCompressResolutionFormat(response?.data?.Compress_image || {});
            } catch (error) {
                console.error("Error fetching compress image config:", error);
                setError(error);
            } finally {
                setLoading(false);
            }
        };

        fetchCompressImageConfig();
    }, []);

    return { compressResolutionFormat, loading, error };
};

export default useCompressImageConfig;

